import { createDataSource } from '@/models/data-source';
import ApiService from '@/services/api.service';
import PasswordGenerator from '@/lib/password-generator';
import dayjs from 'dayjs';

import guid from '@/lib/guid';
const dataSource = createDataSource({});


const df = {
    x: 0,
    y: 0,
    w: 12,
    h: 6,
    i: "0"
};

export const elements = [
    {
        type: "input",
        name: "Text",
        create: function () {
            const data = {
                type: "input",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "date",
        name: "Date",
        create: function () {
            const data = {
                type: "date",
                column: "",
                label: "Enter Date (YYYY-MM-DD)",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true,
                mask: '####-##-##'
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "time",
        name: "Time",
        create: function () {
            const data = {
                type: "time",
                column: "",
                label: "Enter Time (HH:MM)",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true,
                mask: '##:##'
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "textarea",
        name: "Long Text",
        create: function () {
            const data = {
                type: "textarea",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            grid.h = 18;
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "password",
        name: "Password",
        label: "Enter Your Field Label",
        create: function () {
            const data = {
                type: "password",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "number",
        name: "Number",
        create: function () {
            const data = {
                type: "number",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "select",
        name: "Select",
        label: "Label",
        column: "config",
        columnType: "json",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ],
        create: function () {
            const data = {
                type: "select",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true,
                hasList: true,
                models: []
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "combobox",
        name: "Combobox",
        selectType: "items",
        column: "modules",
        items: [
            { value: "awb", text: "Air Waybills" },
            { value: "dss", text: "Document Scanning Solution" },
            { value: "admin", text: "Admin" }
        ],
        create: function () {
            const data = {
                type: "combobox",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true,
                hasList: true,
                models: []
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "slider",
        name: "Slider",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ]
    },
    {
        type: "file",
        name: "File",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ],
        create: function () {
            const data = {
                type: "file",
                column: "",
                label: "Enter Button Text",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: false,
                color: '',
                namespace: '',
                hasSubChart: true,
                subChartValue: null
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "switch",
        name: "Switch",
        create: function () {
            const data = {
                type: "switch",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "checkbox",
        name: "Checkbox",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ]
    },
    {
        type: "time-picker",
        name: "Time Picker",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ]
    },
    {
        type: "date-picker",
        name: "Date Picker",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ]
    },
    {
        type: "date-time-picker",
        name: "Time Picker",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ]
    },
    {
        code: "rating",
        name: "Rating",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ]
    },
    {
        type: "auto-complete",
        name: "Auto Complete",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "text", switch: false, switchcode: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "text", switch: false, code: "helpblock", label: "Hep Block" },
        ]
    },
    {
        type: "editor-element",
        name: "Editor",
        Label: "Label",
        model: null,
        placeholder: null,
        properties: [
            { type: "text", code: "label", label: "Label", class: "" },
            { type: "switch:text", code: "placeholder", label: "Placeholder" },
            { type: "switch", code: "required", label: "Required" },
            { type: "switch:text", code: "helpblock", label: "Hep Block" },
        ],
        create: function () {
            const data = {
                type: "editor-element",
                column: "",
                label: "Enter Your Field Label",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    },
    {
        type: "button",
        name: "Button",
        create: function () {
            const data = {
                type: "button",
                column: "",
                label: "Enter Button Text",
                model: null,
                placeholder: null,
                properties: [],
                switchable: false,
                required: true,
                color: 'blue',
                style: 'width: 100%; height: 50px;',
                onClickFunctionEnabled: true
            };
            const element = new FormElement(data);
            let grid = { ...df, ...{ i: guid.createId('form-grid') } };
            // grid.id = guid.createId('form-grid');
            grid.element = element;
            return grid;
        }
    }
];

const appearance = [

];

const styles = [
    {
        code: "",
        group: "",
    },
];


import {
    nFormatter,
    createSeries,
    createSQL,
    seriesHead,
    appendAggregateValues,
    seriesDataItem,
    pickItem,
    isDateTransformation,
    highestModel,
    averageModel,
    missingValuesModel,
    resolve,
    getSeriesColors,
    extractColors
} from "@/components/charts/common";
import { it } from 'date-fns/locale';




//   type: "password",
//   name: "password",
//   label: "Enter Your Field Label",
//   hint: "Min 8 Characters",
//   model: null,
//   show: false,
//   placeholder: null,
function isEmpty(obj) {
    if(!obj) {
        return true;
    }
    try {
        return Object.keys(obj).length === 0;
} catch(error) {

}
return false;
  }
export class FormElement {
    constructor({
        id = null,
        type = 'input',
        name = null,
        column = ``,
        label = 'Enter Your Field Label',
        hint = null,
        model = null,
        models = [],
        show = false,
        placeholder = null,
        switchable = false,
        style = '',
        className = '',
        properties = [],
        required = false,
        listType = null,
        sql = null,
        json = null,
        items = [],
        hasList = false,
        color = '',
        onClickFunctionEnabled = false,
        defaultColumns = "",
        functionType = "",
        functionValue = "",
        updateColumns = '',
        successMessage = "",
        errorMessage = "",
        hasSubChart = false,
        subChartValue = null,
        mask = null,
        namespace = null,
        folder = null,
        designType = 'outline',
        multiple = false,
        itemText = "text",
        itemValue = "value",
        chart = null,
        isNumeric = false,
        tabIndex = null,
    } = {}) {

        this.id = id;
        if (!this.id) {
            this.id = guid.createId('form-element');
        }


        this.type = type;
        this.name = name;
        this.column = column;
        this.label = label;
        this.hint = hint;
        this.model = null;
        this.models = [];
        this.show = show;
        this.placeholder = placeholder;
        this.switchable = switchable;
        this.style = style;
        this.className = className;
        this.properties = properties;
        this.required = required;
        this.listType = listType;
        this.sql = sql;
        this.json = json;
        this.hasList = hasList;
        this.color = color;
        this.style = style;
        this.items = items;
        this.defaultColumns = defaultColumns;
        this.functionType = functionType;
        this.functionValue = functionValue;
        this.onClickFunctionEnabled = type == 'button' ? true : false;
        this.updateColumns = updateColumns;

        this.successMessage = successMessage;
        this.errorMessage = errorMessage;
        this.loading = false;
        this.hasSubChart = hasSubChart;
        this.subChartValue = subChartValue;
        this.mask = mask;
        this.defaultModel = null;
        this.namespace = namespace;
        this.folder = folder;
        this.designType = designType;
        this.multiple = multiple;
        this.itemText = itemText;
        this.itemValue = itemValue;
        this.tabIndex = tabIndex;

        if(!this.namespace) {
            this.namespace = guid.createId('file-namespace');
        }

        this.isNumeric = isNumeric;

        this.chart = null;
        this.loadItems();
    }

    async loadItems() {
        const that = this;
        try {
            if (this.listType == "sql") {
                let params = {};
                params.sql = window.btoa(this.sql);
                params.pre = 1;
                params.totalItems = 1000;
                params.rowsPerPage = 1000;
                ApiService.query('/datasource/sql/' + 979, {
                    params: params
                }).then(function (response) {
                    that.items = response.data.results;
                    console.log('response', response);
                }).catch(function (error) {

                });
            } else if (this.listType == "json") {
                this.items = JSON.parse(this.json);
                console.log("this.items", this.items);
            }
        } catch (error) {
            console.log("error", error);
        }
    }

    loadJsonColumnValue(data) {
        
        try {
            let tree = {};
            const split = this.column.split('.');
            if(split.length > 1) {
                tree[split[0]] = JSON.parse(data[split[0]]);
                // console.log("loadJsonColumnValue " + this.column, tree[split[0]]);
                const value = resolve(this.column, tree);
                if(Array.isArray(value)) {
                    this.models = value;
                } else {
                    this.model = value;
                }
            }
            
        } catch(error) {
            // console.log("loadJsonColumnValue " + this.column, error);
        }
    }
    selectFile(file) {

    }
    loadColumnValue(data) {
        if(this.type == 'password') {
            return false;
        }
        // let set = false;
        try {
            const value = data[this.column];
            this.model = value;
            if(this.type == 'switch') {
                this.model = this.model === 'true' ? true : this.model;
                this.model = this.model === 'false' ? false : this.model;
            }

            if(this.isNumeric == true) {
                this.model = Number(value);
                if(isNaN(this.model)) {
                    this.model = null;
                }
            }
            // set = true;
        } catch(error) {
            // 
        }
        this.loadJsonColumnValue(data);

        if(this.type == 'date' && !this.model) {
        
            this.model = dayjs().format('YYYY-MM-DD');
        }
        if(this.type == 'time' && !this.model) {
            this.model = dayjs().format('HH:mm');
        }

        
    }
    addValue(value) {
        try {
            this.model.push(value);
        } catch(error) {
            this.model = [];
            this.model.push(value);
        }
    }
    removeValue() {

    }
    clearListValues() {
        this.model = [];
    }

    setModel(model) {
        this.model = model;
    }


    getMentions() {
        let mentions = [];
        try {
            console.log("this.getLayout()", this.getLayout());
            const data = this.getMentionConfig(this.getLayout());
            console.log("mention config", data);
            const d = this.extractMentions(data);
            mentions = d;
        } catch(error) {
            console.log("error", error);
        }
        return mentions;
     
    }

    getMention(obj) {
        try {
            const id = obj.id;
            const label = obj.label;
            
            return {id: id, value: label};
        } catch(error) {
            
        }
        return null;
    }

    getMentionConfig(layout) {

  
            for(let i = 0; i < layout.length; i++) {
                const item = layout[i];
                const column = item.element.column;
                console.log("column", column);
                if(column == 'mention' || column == 'mentions' || column == 'variable' || column == 'variables') {
                    return JSON.parse(item.element.model);

                }
            }
        return null;
    }

    extractMentions(data) {
        let results = [];
        const that =  this;
        const items = data.items;
        for(var i = 0; i < items.length; i++) {
            const item = items[i];
            
            
            //if(item.display == 'properties') {}
            if(typeof item.data != "undefined") {
                const data = item.data;
                for(var j = 0;  j < data.length; j++) {
                    let d = that.getMention(data[j]);
                    if(d) {
                        results.push(d);
                    }
                }
              
            }
            
        }
        return results;
        
    }

    generatePassword() {
        const passwordGenerator = new PasswordGenerator();
        const rules = this.shuffleArray([
            {type: 'uppercase', length: 4}, 
            {type: 'lowercase', length: 2}, 
            {type: 'number', length: 2},
            {type: 'special', length: 2}
        ]);

        let result = "";
        for(let i = 0; i < rules.length; i++) {
            const rule = rules[i];
            result += passwordGenerator.generate(rule.type, rule.length);
        }
        return result;
    }

    shuffleArray(array) {
        for(let i = array.length-1; i > 0; i--) {
            const j = Math.floor(Math.random() * i)
            const temp = array[i]
            array[i] = array[j]
            array[j] = temp
          }

          return array;
          
    }

    loadElements() {

    }

    setProperties() {

    }

    loadElementValues() {

    }


    createTextProperties() {

    }

    createTextAreaProperties() {

    }
    clicked() {

    }
}
let creators = {
    input: function create(type, data) {

    },
    textarea: function create(type, data) {

    },
    textarea: function create(type, data) {

    }
};
export function createElement(type, data) {

}

function getTableName(parameters) {
    try {
        let layout = JSON.parse(resolve("schema.value", parameters));
        console.log("layout", layout);
        for(let i = 0; i < layout.length; i++) {
            const element = layout[i].element;

            if(element.functionType == 'dataUpdateTable' && element.functionValue)  {
                return element.functionValue;
            }
        }
    } catch(error) {
        console.log(error);
    }
    return null;
}

export default async function  hydrator(parameters, data, chart) {

    chart.loading = true;
    chart.status.loadingData = true;
    chart.setLoading(chart.status.loadingData);

    // alert(chart.status.loadingData);
    // alert("hey");
    //  Set tab
    // chart.tab = 0;
    // chart.setTab = function (tab) {
    //     chart.tab = tab
    // }

    // Active element conrol

    // console.log("dialogItem", chart.getReference("dialogItem"));
    // console.log("dialogParams", chart.getReference("dialogParams"));

    // console.log("chart.state.dataSources", chart.tree);


    // console.log("parameters", parameters);

    let dialogItem = chart.getReference("dialogItem");
    const dialogParams = chart.getReference("dialogParams");

    //console.log("dialogItem", dialogItem);

    chart.mode = "add";
    chart.updateId = null;

    if(dialogItem && dialogParams) {
        try {
            const mode = dialogParams.mode;
            const updateId = dialogParams.mode;
            chart.mode = mode;
            chart.updateId = updateId;
            const dialogAttrItem = JSON.parse(dialogItem.attr_data);
            if(dialogAttrItem) {
                dialogItem = dialogAttrItem;
            }
        } catch(error) {
            console.log("error", error);

        }
    }



    chart.activeElement = null;
    chart.activeGrid = null;

    chart.ui = null;
    

    let parameterisedFilterObject = resolve("tree.parameterisedFilterObject", chart, {});
    const tableName = getTableName(parameters);

    // console.log("tableName", tableName);

    let item = null;
    try {
        item = JSON.parse(parameterisedFilterObject.attr_data);
    } catch {
        item = parameterisedFilterObject;
    }

    if(dialogItem && typeof dialogItem.id != "undefined" && tableName) {
        try {
            chart.status.loadingData = true;
            const response = await ApiService.query("/datasource/data/" + tableName + "/" + dialogItem.id, {});
            if(response && typeof response.data != "undefined") {
                dialogItem = response.data;
            }
        } catch(error) {

        }
    }

    chart.status.loadingData = false;
    chart.setLoading(chart.status.loadingData);
    // alert(chart.status.loadingData);
    // alert(chart.id);


    chart.save = function (input) {
        // chart.layout = typeof input != "undefined" && input ? input : chart.layout;
        if(Array.isArray(input)) {
            chart.layout = input;
            let layout = JSON.stringify(input);
            parameters.schema.value = layout;

            if(typeof chart.setViewLayout != "undefined") {
                chart.setViewLayout(input);
            }
           // console.log("chart.layout", chart.layout);
           // console.log("saved", layout);
        }
        
        
    }


    chart.loadedFromSchema = null;
    chart.loadFromSchema = function (f) {
        const force  = typeof f != "undefined" ? f : false; 
        if (!chart.loadedFromSchema || force == true) {
            try {
                // alert("load from schema");
                // console.log("parameters", parameters);
                let schema = JSON.parse(resolve("schema.value", parameters));
                let layout = [];
                for (let i = 0; i < schema.length; i++) {
                    const grid = schema[i];
                    grid.element = new FormElement(grid.element);
                    // grid.element.chart = chart;
                    grid.element.getLayout = function() {
                        return layout;
                    }
                    // console.log("loadColumnValue", dialogItem);
                    grid.element.loadColumnValue(dialogItem);
                    // console.log("dialogItem.attr_item", dialogItem);
                    // if(dialogItem && typeof dialogItem.attr_item != "undefined") {
                    //     grid.element.loadColumnValue(dialogItem.attr_item);
                    // }
                    layout.push(grid);
                }

                chart.loadedFromSchema = layout;
                // chart.layout = layout;
                // l = layout;
                // if(typeof chart.setLayout != "undefined") {
                //     chart.setLayout(layout);
                // }

                // this.layout = layout;

                // console.log("schema", schema);
                // console.log("parameters", parameters);

            } catch (error) {
                console.log('error', error);
            }
        }

        console.log("chart.loadedFromSchema", chart.loadedFromSchema);

        // l = chart.loadedFromSchema;
        if (typeof chart.setLayout != "undefined" && chart.loadedFromSchema) {
            chart.setLayout(chart.loadedFromSchema);
        }
        if (typeof chart.setViewLayout != "undefined" && chart.loadedFromSchema) {
            chart.setViewLayout(chart.loadedFromSchema);
        }


    }

    chart.setActiveGrid = function (grid) {

        chart.activeGrid = grid;
        chart.activeElement = grid.element;

        if(typeof chart.setActiveElement != "undefined") {
            chart.setActiveElement(grid.element);
        }

        if(typeof chart.setTab != "undefined") {
            chart.setTab(1);
        }
        
        // chart.save();
        // alert("setActiveGrid " + grid);
        // alert("setActiveGrid");
        // if (chart.activeElement && chart.activeElement.id == element.id) {
        //     chart.activeElement = element;
        //     chart.setTab(1);
        // } else {
        //     chart.activeElement = element;
        //     chart.setTab(1);
        // }
    }

    chart.layout = [];


    chart.createGridElement = function (item, element) {
        // const grid = element.grid;
        

        if (typeof element.create != "undefined") {
            let grid = element.create();
            grid.element.chart = element;
            grid.element.getLayout = function() {
                return chart.layout;
            }

            grid.x = item.x;
            grid.y = item.y;
            grid.w = item.w;
            grid.h = item.h;
            return grid;


        }

        return null;

}
    chart.addElement = function (item, element, index) {
        // const grid = element.grid;
        

        if (typeof element.create != "undefined") {
            let grid = element.create();
            grid.element.chart = element;
            grid.element.getLayout = function() {
                return chart.layout;
            }

            grid.x = item.x;
            grid.y = item.y;
            grid.w = item.w;
            grid.h = item.h;

            chart.layout.push(grid);
            chart.setActiveGrid(grid);

            // if (item) {
            //     grid.x = item.x + item.h;
            //     chart.layout.splice(index+1, 0, grid);
            //     console.log("index 1", index);
            //     console.log("grid 1", grid);
            //     let prev = null;
            //     for(let i = 0; i < chart.layout.length; i++) {
            //         const g = chart.layout[i];
            //         if(g.x >= grid.x && prev) {
            //             g.x = prev.x + prev.h;
            //         }
            //         prev = g;
            //     }

            //     console.log("chart.layout", chart.layout);

            //     // const index = this.layout.indexOf(item);
                
            //     chart.setActiveGrid(grid);
            // } else {
            //     grid.x = 0;
            //     chart.layout.push(grid);
            //     chart.setActiveGrid(grid);
            // }
        }
        //chart.save();
        // chart.setLayout(chart.layout);
        // console.log(JSON.stringify(chart.layout));
        // if (typeof transferData.data.grid != "undefined") {
        //     newItem = { ...newItem, ...transferData.data.grid };
        // }
        // newItem.element = transferData.data;
        // newItem.x = newItem.x + 1;
        // const index = this.layout.indexOf(item);
        // newItem.i = "New " + index;
        // this.layout.splice(index + 1, 0, newItem);
        // console.log("newItem", newItem);
    }

    chart.functions = {};
    chart.functions.resetForm = function (triggerElement) {
        const form = chart.getForm();
        form.reset();
    }
    chart.functions.dataUpdateTable = async function(triggerElement) {
        const layout = chart.getPostData();
        const payload = { grids: layout, type: "update", item: dialogItem, triggerElement: triggerElement };
        // console.log("payload", payload);
        const form = chart.getForm();


        if (form.validate()) {
            triggerElement.loading = true;
            try {
                await ApiService.post("/datasource/data", payload);
                chart.success(triggerElement);
                // console.log("response", response);
            } catch(error) {
                chart.error(triggerElement);
                // console.log("error", error);
            }
            triggerElement.loading = false;
            // alert("valid");
        } else {
            // console.log('payload', payload);
            // alert("invalid 1");
        }

    }

    chart.functions.dataAddTable = async function(triggerElement) {

        const layout = chart.getPostData();
        const payload = { grids: layout, type: "insert", triggerElement: triggerElement };
 

        const form = chart.getForm();

        if (form.validate()) {
            triggerElement.loading = true;
            try {
                await ApiService.post("/datasource/data", payload);

                chart.success(triggerElement);
                // console.log("response", response);
            } catch(error) {
                chart.error(triggerElement);
                console.log("error", error);
            }
            triggerElement.loading = false;
            // alert("valid");
        } else {
            // alert("invalid 1");
        }

    }

    chart.functions.api = function (triggerElement) {

    }

    chart.functions.openDashboard = function (triggerElement) {
        const name = triggerElement.functionValue;
        // console.log("chart", chart);
        if(typeof chart.openDashboard != "undefined") {
            chart.openDashboard(name);
        }
        
    }

    chart.functions.openLink = function (triggerElement) {

    }


    chart.send = function (triggerElement) {


        try {
            console.log("triggerElement", triggerElement);
            chart.functions[triggerElement.functionType](triggerElement);

        } catch (error) {
            console.log("error", error);
        }


        // if(typeof chart.getForm != "undefined") {
        //     const form = chart.getForm();
        //     // form.reset();

        //     console.log("form", form);
        // if (form.validate()) {
        //     if(form.value == true) {
        //         alert("valid");
        //     } else {
        //         alert("invalid 0");
        //     }
        //     // chart.$formRef.reset();
        //   } else {
        //     alert("invalid 0");
        //   }
        // }


        // this.$validator.validateAll().then(function(response) {
        //     if(response === true) { 
        //         alert("validated");
        //     }
        //   }).catch(function(e) {

        //   });

        // console.log("layout", layout);

        // try {
        //     ApiService.post("/datasource/data", payload);
        // } catch(error) {

        // }
    }

    console.log("loading from schema");
    chart.loadFromSchema();
    chart.loading = false;

}
